import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { formatToDate } from "../master/FormatToDateTime";
import usePrivateLink from "../config/usePrivateLink";
import { studentDetailsV2 } from "../../api/Student";
import { imgBaseUrl } from "../../api/api";

import CourseNFees from "./CourseNFees";
import FeeTransactions from "../student/tabs/FeeTransactions";
import MarkReports from "../student/tabs/MarkReports";
import AttendanceCalendar from "../student/tabs/Attendance";
import BasicV2Details from "./BasicDetails";
import "./BasicDetails.css";
import Master from "../student/Master";
import StudentAdmissionForm from "../student/tabs/StudentAdmissionForm";
import StudentDemoForm from "../student/tabs/StudentDemoForm";
import { getDetails } from "../../api/HostelService";
import CourseNFeeTab from "../hostel/v2/CourseNFeeTab";

/* ─── Small helper components ────────────────────────────────────────── */
function InfoRow({ icon, iconBg, iconColor, label, value }) {
  return (
    <div className="sd-info-row">
      <div className="sd-info-icon" style={{ background: iconBg }}>
        <i className={icon} style={{ color: iconColor }}></i>
      </div>
      <div>
        <div className="sd-info-label">{label}</div>
        <div className="sd-info-value">{value || "—"}</div>
      </div>
    </div>
  );
}


/* ─── Main Component ─────────────────────────────────────────────────── */
export default function StudentDetails() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id") ?? "";

  const [data, setData] = useState({});
  const type = params.get("type") ?? "BasicDetails";
  const [hostelData, setHostelData] = useState(null);


  const [filters, setFilters] = useState({
    type: type,
    course_and_fee_id: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("type", filters?.type);
    navigate(
      `${location.pathname}?${params.toString()}`,
      { replace: true }
    );
  }, [filters?.type]);

  useEffect(() => {
    if (
      filters?.type === "Hostel" &&
      data?.hostel_student_id
    ) {
      getHostelData();
    }
  }, [filters?.type, data?.hostel_student_id]);


  const getHostelData = async () => {
    try {
      const response = await getDetails(data?.hostel_student_id);

      if (response?.data?.status) {
        setHostelData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const TABS = [
    { icon: "ri-user-3-line", label: "Basic Details", link: "BasicDetails" },
    { icon: "ri-book-open-line", label: "Course & Fees", link: "CourseNFees" },
    {
      icon: "ri-bar-chart-grouped-line",
      label: "Mark Report",
      link: "MarkReport",
    },
    { icon: "ri-calendar-check-line", label: "Attendance", link: "Attendance" },
    {
      icon: "ri-calendar-check-line",
      label: "Admission Form",
      link: "AdmissionForm",
    },
    { icon: "ri-calendar-check-line", label: "Demo Form", link: "DemoForm" },

    ...(data?.hostel_student_id
      ? [
        {
          icon: "ri-hotel-bed-line",
          label: "Hostel",
          link: "Hostel",
        },
      ]
      : []),

    ...(data?.library_student_id
      ? [
        {
          icon: "ri-book-2-line",
          label: "Library",
          link: `/library/student/profile?id=${data?.library_student_id}`,
          isRedirect: true,
        },
      ]
      : []),
    ...(data?.bus_student_id
      ? [
        {
          icon: "ri-bus-2-line",
          label: "Bus",
          link: "Bus",
        },
      ]
      : []),
  ];

  const getDataList = async () => {
    setLoading(true);
    let addUrl = `id=${id}`;
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) addUrl += `&${key}=${encodeURIComponent(value)}`;
    });
    try {
      const response = await studentDetailsV2(addUrl);
      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataList();
  }, [filters]);

  /* Avatar fallback */
  const [imgError, setImgError] = useState(false);
  const initials = data?.name ? data.name.charAt(0).toUpperCase() : "?";

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar sd-page">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row g-2">
                  <Master />
                  <div className="col-12">
                    <div className="row g-4">
                      {/* <div className="col-xl-3 col-lg-4 col-md-5 sd-fadein sd-fadein-1">
                        <div className="sd-card ">

                          <div className="sd-profile-banner bg-primary" />


                          <div className="px-3 pb-3">
                            <div className="sd-avatar-wrap  d-flex justify-content-center mb-2">
                              <div style={{ position: "relative" }}>
                                {data?.profile_picture && !imgError ? (
                                  <img
                                    src={imgBaseUrl + data.profile_picture}
                                    alt="avatar"
                                    className="sd-avatar"
                                    onError={() => setImgError(true)}
                                  />
                                ) : (
                                  <div className="sd-avatar">{initials}</div>
                                )}
                                <div className="sd-online-dot" />
                              </div>
                            </div>

                            <div className="text-center mb-2">
                              <h5
                                className="fw-800 mb-0"
                                style={{ fontSize: "1rem", color: "#0f172a" }}
                              >
                                {data?.name || "—"}
                              </h5>
                              <div className="text-muted small mt-1">
                                <i className="ri-shield-keyhole-line me-1"></i>
                                {data?.registration_no || "—"}
                              </div>
                              <div className="d-flex justify-content-center gap-1 mt-2 flex-wrap">
                                {data?.category && (
                                  <span
                                    className="badge rounded-pill"
                                    style={{
                                      background: "#dbeafe",
                                      color: "#1d4ed8",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    {data.category}
                                  </span>
                                )}
                                {data?.gender && (
                                  <span
                                    className="badge rounded-pill"
                                    style={{
                                      background: "#dcfce7",
                                      color: "#166534",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    {data.gender}
                                  </span>
                                )}
                              </div>
                            </div>

                            <hr className="my-2" />


                            <InfoRow
                              icon="ri-user-3-line"
                              iconBg="#eff6ff"
                              iconColor="#1a73e8"
                              label="Father's Name"
                              value={data?.father_name}
                            />
                            <InfoRow
                              icon="ri-user-heart-line"
                              iconBg="#fdf4ff"
                              iconColor="#9333ea"
                              label="Mother's Name"
                              value={data?.mother_name}
                            />
                            <InfoRow
                              icon="ri-mail-line"
                              iconBg="#f0fdf4"
                              iconColor="#16a34a"
                              label="Email"
                              value={data?.email}
                            />
                            <InfoRow
                              icon="ri-phone-line"
                              iconBg="#fff7ed"
                              iconColor="#ea580c"
                              label="Mobile"
                              value={[data?.phone, data?.secondary_mobile]
                                .filter(Boolean)
                                .join(", ")}
                            />
                            <InfoRow
                              icon="ri-cake-3-line"
                              iconBg="#fef9c3"
                              iconColor="#ca8a04"
                              label="Date of Birth"
                              value={formatToDate(data?.dob)}
                            />
                            <InfoRow
                              icon="ri-calendar-event-line"
                              iconBg="#ecfdf5"
                              iconColor="#059669"
                              label="Admission Date"
                              value={formatToDate(data?.admission_date)}
                            />
                            <InfoRow
                              icon="ri-map-pin-line"
                              iconBg="#fff1f2"
                              iconColor="#e11d48"
                              label="Address"
                              value={[
                                data?.village,
                                data?.district,
                                data?.state,
                                data?.zipcode,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            />
                            <InfoRow
                              icon="ri-fingerprint-line"
                              iconBg="#f0fdf4"
                              iconColor="#15803d"
                              label="Aadhar"
                              value={data?.aadhar}
                            />
                            <InfoRow
                              icon="ri-briefcase-line"
                              iconBg="#eef2ff"
                              iconColor="#6366f1"
                              label="Father Occupation"
                              value={data?.father_occupation}
                            />

                            <InfoRow
                              icon="ri-graduation-cap-line"
                              iconBg="#ecfeff"
                              iconColor="#06b6d4"
                              label="Education"
                              value={
                                Array.isArray(data?.education)
                                  ? data.education.map((e) => e.name).join(", ")
                                  : data?.education
                              }
                            />

                            <InfoRow
                              icon="ri-book-line"
                              iconBg="#fef3c7"
                              iconColor="#f59e0b"
                              label="Medium"
                              value={data?.medium}
                            />

                            <InfoRow
                              icon="ri-hotel-bed-line"
                              iconBg="#f0f9ff"
                              iconColor="#0ea5e9"
                              label="Hostel"
                              value={data?.hostel_status}
                            />
                            <InfoRow
                              icon="ri-bus-line"
                              iconBg="#ecfdf5"
                              iconColor="#10b981"
                              label="Bus"
                              value={data?.bus_status}
                            />

                            <hr className="my-3" />


                            <div className="row g-2">
                              {hasAccess("/student/update") && (
                                <div className="col-12 col-md-6">
                                  <Link to={`/student/update?id=${data?.id}`}>
                                    <button
                                      className="btn btn-primary w-100 btn-sm fw-600"
                                      style={{ borderRadius: "10px" }}
                                    >
                                      <i className="ri-pencil-line me-1"></i>
                                      Edit Profile
                                    </button>
                                  </Link>
                                </div>
                              )}

                              {hasAccess("/student/fees/deposit") && (
                                <div className="col-12 col-md-6">
                                  <Link
                                    to={`/student/fees/deposit?id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-money-rupee-circle-line me-1"></i>
                                    Pay Fees
                                  </Link>
                                </div>
                              )}

                              {hasAccess("/student/batch/enroll") && (
                                <div className="col-6 ">
                                  <Link
                                    to={`/student/batch/enroll?student_id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-group-line me-1"></i>
                                    Add in Batch
                                  </Link>
                                </div>
                              )}
                              {hasAccess("/student/bus/enroll") && (
                                <div className="col-6">
                                  <Link
                                    to={`/student/bus/enroll?student_id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-bus-line me-1"></i>
                                    Add to Bus
                                  </Link>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div> */}


                      <div className="col-xl-3 col-lg-4 col-md-5 sd-fadein sd-fadein-1">

                        <div
                          className="sd-card d-flex flex-column"
                          style={{ height: "calc(100vh - 120px)" }}
                        >

                          {/* FIXED TOP */}
                          <div>

                            {/* Banner */}
                            <div className="sd-profile-banner bg-primary" />

                            {/* Avatar + name */}
                            <div className="px-3 pt-3">

                              <div className="sd-avatar-wrap d-flex justify-content-center mb-2">
                                <div style={{ position: "relative" }}>
                                  {data?.profile_picture && !imgError ? (
                                    <img
                                      src={imgBaseUrl + data.profile_picture}
                                      alt="avatar"
                                      className="sd-avatar"
                                      onError={() => setImgError(true)}
                                    />
                                  ) : (
                                    <div className="sd-avatar">{initials}</div>
                                  )}

                                  <div className="sd-online-dot" />
                                </div>
                              </div>

                              <div className="text-center mb-2">
                                <h5
                                  className="fw-800 mb-0"
                                  style={{ fontSize: "1rem", color: "#0f172a" }}
                                >
                                  {data?.name || "—"}
                                </h5>

                                <div className="text-muted small">
                                  <i className="ri-shield-keyhole-line me-1"></i>
                                  {data?.registration_no || "—"}
                                </div>

                                <div className="d-flex justify-content-center gap-1 flex-wrap">

                                  {data?.category && (
                                    <span
                                      className="badge rounded-pill"
                                      style={{
                                        background: "#dbeafe",
                                        color: "#1d4ed8",
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      {data.category}
                                    </span>
                                  )}

                                  {data?.gender && (
                                    <span
                                      className="badge rounded-pill"
                                      style={{
                                        background: "#dcfce7",
                                        color: "#166534",
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      {data.gender}
                                    </span>
                                  )}

                                </div>
                              </div>

                              <hr className="my-2" />
                            </div>
                          </div>

                          {/* ONLY INFO SCROLL */}
                          <div
                            className="flex-grow-1 overflow-auto px-3"
                            style={{ minHeight: 0 }}
                          >

                            <InfoRow
                              icon="ri-user-3-line"
                              iconBg="#eff6ff"
                              iconColor="#1a73e8"
                              label="Father's Name"
                              value={data?.father_name}
                            />

                            <InfoRow
                              icon="ri-user-heart-line"
                              iconBg="#fdf4ff"
                              iconColor="#9333ea"
                              label="Mother's Name"
                              value={data?.mother_name}
                            />

                            <InfoRow
                              icon="ri-mail-line"
                              iconBg="#f0fdf4"
                              iconColor="#16a34a"
                              label="Email"
                              value={data?.email}
                            />


                            <InfoRow
                              icon="ri-phone-line"
                              iconBg="#fff7ed"
                              iconColor="#ea580c"
                              label="Mobile"
                              value={data?.phone || "-"}
                            />

                            <InfoRow
                              icon="ri-smartphone-line"
                              iconBg="#eff6ff"
                              iconColor="#2563eb"
                              label="Secondary Mobile"
                              value={data?.secondary_mobile || "-"}
                            />

                            <InfoRow
                              icon="ri-government-line"
                              iconBg="#fff7ed"
                              iconColor="#ea580c"
                              label="Type"
                              value={data?.course_and_fee_info?.rte || "NONRTE"}
                            />

                            <InfoRow
                              icon="ri-cake-3-line"
                              iconBg="#fef9c3"
                              iconColor="#ca8a04"
                              label="Date of Birth"
                              value={formatToDate(data?.dob)}
                            />

                            <InfoRow
                              icon="ri-calendar-event-line"
                              iconBg="#ecfdf5"
                              iconColor="#059669"
                              label="Admission Date"
                              value={formatToDate(data?.admission_date)}
                            />

                            <InfoRow
                              icon="ri-map-pin-line"
                              iconBg="#fff1f2"
                              iconColor="#e11d48"
                              label="Address"
                              value={[
                                data?.village,
                                data?.district,
                                data?.state,
                                data?.zipcode,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            />

                            <InfoRow
                              icon="ri-fingerprint-line"
                              iconBg="#f0fdf4"
                              iconColor="#15803d"
                              label="Aadhar"
                              value={data?.aadhar}
                            />

                            <InfoRow
                              icon="ri-briefcase-line"
                              iconBg="#eef2ff"
                              iconColor="#6366f1"
                              label="Father Occupation"
                              value={data?.father_occupation}
                            />

                            <InfoRow
                              icon="ri-graduation-cap-line"
                              iconBg="#ecfeff"
                              iconColor="#06b6d4"
                              label="Education"
                              value={
                                Array.isArray(data?.education)
                                  ? data.education.map((e) => e.name).join(", ")
                                  : data?.education
                              }
                            />

                            <InfoRow
                              icon="ri-book-line"
                              iconBg="#fef3c7"
                              iconColor="#f59e0b"
                              label="Medium"
                              value={data?.medium}
                            />



                            <div
                              style={{
                                cursor: data?.hostel_student_id ? "pointer" : "default",
                              }}
                              onClick={() => {
                                if (data?.hostel_student_id) {
                                  navigate(
                                    `/hostel/profile?id=${data.hostel_student_id}`
                                  );
                                }
                              }}
                            >
                              <InfoRow
                                icon="ri-hotel-bed-line"
                                iconBg="#f0f9ff"
                                iconColor="#0ea5e9"
                                label="Hostel"
                                value={
                                  data?.hostel_student_id
                                    ? "Yes"
                                    : data?.hostel_status || "No"
                                }
                              />
                            </div>

                            <InfoRow
                              icon="ri-bus-line"
                              iconBg="#ecfdf5"
                              iconColor="#10b981"
                              label="Bus"
                              value={data?.bus_status}
                            />

                          </div>

                          {/* FIXED BUTTONS */}
                          <div className="p-3 border-top ">

                            <div className="row g-2">

                              {hasAccess("/student/update") && (
                                <div className="col-6">
                                  <Link to={`/student/update?id=${data?.id}`}>
                                    <button
                                      className="btn btn-primary w-100 btn-sm fw-600"
                                      style={{ borderRadius: "10px" }}
                                    >
                                      <i className="ri-pencil-line me-1"></i>
                                      Edit Profile
                                    </button>
                                  </Link>
                                </div>
                              )}

                              {hasAccess("/student/fees/deposit") && (
                                <div className="col-6">
                                  <Link
                                    to={`/student/fees/deposit?id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-money-rupee-circle-line me-1"></i>
                                    Pay Fees
                                  </Link>
                                </div>
                              )}

                              {hasAccess("/student/batch/enroll") && (
                                <div className="col-6">
                                  <Link
                                    to={`/student/batch/enroll?student_id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-group-line me-1"></i>
                                    Add in Batch
                                  </Link>
                                </div>
                              )}

                              {hasAccess("/student/bus/enroll") && (
                                <div className="col-6">
                                  <Link
                                    to={`/student/bus/enroll?student_id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-bus-line me-1"></i>
                                    Add to Bus
                                  </Link>
                                </div>
                              )}
                              {hasAccess("/student/documents/add") && (
                                <div className="col-12">
                                  <Link
                                    to={`/student/documents/add?student_id=${data?.id}`}
                                    className="btn btn-outline-secondary btn-sm fw-600 w-100"
                                    style={{ borderRadius: "10px" }}
                                  >
                                    <i className="ri-file-text-line me-1"></i>
                                    Documents Add
                                  </Link>
                                </div>
                              )}

                            </div>

                          </div>

                        </div>

                      </div>

                      {/* ════════════════════════════════════════
                      RIGHT — Tabs + Content
                  ════════════════════════════════════════ */}
                      <div className="col-xl-9 col-lg-8 col-md-7 sd-fadein sd-fadein-2">
                        {/* Tab navigation */}
                        <div className="sd-card mb-3 p-2">
                          <div className="d-flex align-items-center gap-1 flex-wrap">
                            {TABS.map((tab) =>
                              tab?.isRedirect ? (
                                <Link
                                  key={tab.link}
                                  to={tab.link}
                                  className="btn btn-sm btn-outline-primary px-2 py-1"
                                >
                                  <i className={`${tab.icon} ri-20px me-2`}></i>
                                  {tab.label}
                                </Link>
                              ) : (
                                <button
                                  key={tab.link}
                                  className={`btn btn-sm  px-2 py-1 ${filters?.type === tab.link
                                    ? "btn-primary"
                                    : "btn-outline-primary"
                                    }`}
                                  onClick={() =>
                                    setFilters({ ...filters, type: tab.link })
                                  }
                                >
                                  <i className={`${tab.icon} ri-20px me-2`}></i>
                                  {tab.label}
                                </button>
                              ),
                            )}
                          </div>
                        </div>

                        {/* Tab content panel */}

                        <div className="">
                          {filters?.type === "BasicDetails" && (
                            <BasicV2Details
                              data={data}
                              handleFunction={getDataList}
                              setFilters={setFilters}
                            />
                          )}
                          {filters?.type === "CourseNFees" && (
                            <CourseNFees
                              data={data}
                              setLoading={setLoading}
                              handleFunction={getDataList}
                            />
                          )}
                          {filters?.type === "MarkReport" && (
                            <MarkReports data={data} />
                          )}
                          {filters?.type === "Transactions" && (
                            <FeeTransactions
                              data={data}
                              setLoading={setLoading}
                              handleFunction={getDataList}
                            />
                          )}
                          {filters?.type === "Attendance" && (
                            <AttendanceCalendar
                              attendances={data?.attendances}
                              leave={data?.applied_leave_request}
                              setFilters={setFilters}
                            />
                          )}

                          {filters?.type === "AdmissionForm" ? (
                            <StudentAdmissionForm data={data} />
                          ) : filters?.type === "DemoForm" && (
                            <StudentDemoForm data={data} />
                          )}

                          {filters?.type === "Hostel" && hostelData && (
                            <CourseNFeeTab
                              data={hostelData}
                              getStudent={getHostelData}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
